webpackJsonp([0],{

/***/ 171:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export PLUGIN_NAME */
/* unused harmony export DEFAULTS */
/* unused harmony export default */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_jquery__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_jquery___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_jquery__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_styleguide_lib_merge_options__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__lib_register_jquery_plugin__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__lib_props__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__product_filter_count__ = __webpack_require__(61);
/**
 * Sidebar product filter search
 * @module productFilterActiveSearch
 */





var PLUGIN_NAME = 'productFilterActiveButton';
var DEFAULTS = {
  clearAllText: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3__lib_props__["a" /* get */])('rcProps.filter.clearAllText', 'Clear')
};

var createCloseIcon = function createCloseIcon() {
  return "<span class=\"icon icon--x icon--xs u-margin-l--sm\">\n  <svg viewBox=\"0 0 16 16\" aria-hidden=\"true\" focusable=\"false\"\n      role=\"presentation\">\n      <path\n          d=\"M9.06 8l2.72-2.72A.75.75 0 0 0 10.72 4.22L8 6.94 5.28\n             4.22A.75.75 0 0 0 4.22 5.28L6.94 8l-2.72 2.72A.75.75 0 1 0 5.28 11.78L8\n             9.06l2.72 2.72a.75.75 0 0 0 1.061-1.061z\">\n      </path>\n  </svg>\n</span>";
};

var createFilterButton = function createFilterButton(text) {
  return "<li class=\"horizontal-scroll__item\n     horizontal-scroll__item--basis-none\">\n  <button class=\"pill-button pill-button--light-grey\">\n      ".concat(text, "\n      ").concat(createCloseIcon(), "\n  </button>\n</li>");
}; // Getting rid of Clear button for AB testing


var createContainerButtons = function createContainerButtons() {
  return "<div class=\"horizontal-scroll u-margin-b--none u-width-plus-16\">\n  <ul\n      class=\"horizontal-scroll__item-wrap horizontal-scroll__item-wrap--first-no-padding u-margin-b--none\">\n  </ul>\n</div>";
}; // const createContainerButtons = (clearAllText) => `
// <div class="horizontal-scroll u-margin-b--none u-width-plus-16">
//   <ul
//       class="horizontal-scroll__item-wrap horizontal-scroll__item-wrap--first-no-padding
//           u-margin-b--none">
//       <li class="horizontal-scroll__item horizontal-scroll__item--basis-none">
//           <button class="pill-button pill-button--black">
//               ${clearAllText}
//           </button>
//       </li>
//   </ul>
// </div>
// `;


var addButtonsContainer = function addButtonsContainer($container, $checkboxes, _ref) {
  var clearAllText = _ref.clearAllText;
  var $buttonContainer = __WEBPACK_IMPORTED_MODULE_0_jquery___default()(createContainerButtons(clearAllText));
  var $clearAllButton = $buttonContainer.find('button');
  $container.prepend($buttonContainer);
  $clearAllButton.on('click', function () {
    $checkboxes.each(function (index, checkbox) {
      if (checkbox.checked) {
        __WEBPACK_IMPORTED_MODULE_0_jquery___default()(checkbox).prop('checked', false).trigger('change');
      }
    });
  });
  return {
    $buttonListContainer: $buttonContainer,
    $buttonList: $buttonContainer.find('ul')
  };
};

var addButtonToList = function addButtonToList($checkbox, $buttonList) {
  var innserSpan = $checkbox.next().children('span');
  var checkboxText;

  if (innserSpan.length) {
    checkboxText = innserSpan.eq(0).text();
  } else {
    checkboxText = $checkbox.next().text();
  }

  var $filterButton = __WEBPACK_IMPORTED_MODULE_0_jquery___default()(createFilterButton(checkboxText));
  $buttonList.append($filterButton);
  $filterButton.on('click', function () {
    $checkbox.prop('checked', false).trigger('change');
  });
  return $filterButton;
};

var countChecked = function countChecked($checkboxes) {
  return $checkboxes.filter(':checked').length;
};

var checkButtonListVisibility = function checkButtonListVisibility($buttonListContainer, $checkboxes) {
  if (countChecked($checkboxes)) {
    $buttonListContainer.removeClass('u-hide');
    return;
  }

  $buttonListContainer.addClass('u-hide');
};

var initActiveButtons = function initActiveButtons($buttonListContainer, $buttonList, $checkboxes) {
  $checkboxes.each(function (index, checkbox) {
    var $checkbox = __WEBPACK_IMPORTED_MODULE_0_jquery___default()(checkbox);
    var $filterButton;

    if (checkbox.checked) {
      $filterButton = addButtonToList($checkbox, $buttonList);
    }

    $checkbox.on('change', function () {
      if (checkbox.checked) {
        $filterButton = addButtonToList($checkbox, $buttonList);
      } else {
        $filterButton.remove();
      }

      checkButtonListVisibility($buttonListContainer, $checkboxes);
    });
  });
};
/**
 * Initializes productFilterActiveButton.
 * @param {HTMLElement} container - filter container
 * @param {Object} options - Options used for wiring up the plugin
 * @see DEFAULTS
 */


function productFilterActiveButton(container) {
  var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
  var $container = __WEBPACK_IMPORTED_MODULE_0_jquery___default()(container);
  var opts = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_styleguide_lib_merge_options__["a" /* default */])(DEFAULTS, options, $container);
  var $count = __WEBPACK_IMPORTED_MODULE_0_jquery___default()(opts.filterCount);
  var $checkboxes = $container.find('input[type="checkbox"]');

  var _addButtonsContainer = addButtonsContainer($container, $checkboxes, opts),
      $buttonListContainer = _addButtonsContainer.$buttonListContainer,
      $buttonList = _addButtonsContainer.$buttonList;

  initActiveButtons($buttonListContainer, $buttonList, $checkboxes, $count);
  checkButtonListVisibility($buttonListContainer, $checkboxes);
  $container.productFilterCount();
}
__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__lib_register_jquery_plugin__["a" /* default */])(PLUGIN_NAME, productFilterActiveButton);

/***/ }),

/***/ 172:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export PLUGIN_NAME */
/* unused harmony export DEFAULTS */
/* unused harmony export default */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_jquery__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_jquery___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_jquery__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__lib_register_jquery_plugin__ = __webpack_require__(1);
/**
 * Product Filter Clear All
 * @module productFilterClearAll
 */


var PLUGIN_NAME = 'productFilterClearAll';
var DEFAULTS = {};

var ZeroChecked = function ZeroChecked($checkboxes) {
  return $checkboxes.filter(':checked').length === 0;
};

var clearAllVisibility = function clearAllVisibility($checkboxes, $clearButton) {
  var isZeroChecked = ZeroChecked($checkboxes);

  if (isZeroChecked) {
    $clearButton.hide();
  } else {
    $clearButton.show();
  }
};

var onChangeListener = function onChangeListener($checkboxes, $clearButton) {
  return $checkboxes.on('change', function () {
    return clearAllVisibility($checkboxes, $clearButton);
  });
};
/**
 * Initializes productFilterClearAll.
 * @param {HTMLElement} container - filter container
 * @param {Object} options - Options used for wiring up the plugin
 * @see DEFAULTS
 */


function productFilterClearAll(container) {
  var $container = __WEBPACK_IMPORTED_MODULE_0_jquery___default()(container);
  var $checkboxes = $container.find('input[type="checkbox"]');
  var $clearButton = __WEBPACK_IMPORTED_MODULE_0_jquery___default()('.js-product-filter-clear-all-button');
  $clearButton.on('click', function () {
    $checkboxes.each(function (index, checkbox) {
      if (checkbox.checked) {
        __WEBPACK_IMPORTED_MODULE_0_jquery___default()(checkbox).prop('checked', false).trigger('change');
      }
    });
  });
  clearAllVisibility($checkboxes, $clearButton);
  onChangeListener($checkboxes, $clearButton);
}
__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__lib_register_jquery_plugin__["a" /* default */])(PLUGIN_NAME, productFilterClearAll);

/***/ }),

/***/ 173:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export PLUGIN_NAME */
/* unused harmony export DEFAULTS */
/* unused harmony export default */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_jquery__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_jquery___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_jquery__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_styleguide_lib_merge_options__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__lib_register_jquery_plugin__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__lib_props__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__product_filter_count__ = __webpack_require__(61);
/**
 * Sidebar product filter search
 * @module productFilterSearch
 */





var PLUGIN_NAME = 'productFilterSearch';
var DEFAULTS = {
  zeroResultsText: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3__lib_props__["a" /* get */])('rcProps.filter.zeroResults', 'There are 0 results. Try a new search.')
};

var findMatches = function findMatches(phraseToMatch, list) {
  return list.filter(function (item) {
    var regex = new RegExp(phraseToMatch, 'ig');
    return item.value.match(regex);
  }).map(function (item) {
    return item.index;
  });
};

var createData = function createData($checkboxes) {
  return $checkboxes.toArray().map(function (checkbox, index) {
    __WEBPACK_IMPORTED_MODULE_0_jquery___default()(checkbox).data('data-original-text', checkbox.value);
    return {
      value: checkbox.value,
      index: index
    };
  });
};

var highlightText = function highlightText(phraseToMatch, text) {
  var regex = new RegExp(phraseToMatch, 'ig');
  return text.replace(regex, function (match) {
    return "<strong>".concat(match, "</strong>");
  });
};

var createZeroResults = function createZeroResults($container, _ref) {
  var zeroResultsText = _ref.zeroResultsText;
  var $zeroResults = __WEBPACK_IMPORTED_MODULE_0_jquery___default()("<p class='u-hide'>".concat(zeroResultsText, "</p>"));
  $container.find('#designer-search').closest('.field').after($zeroResults);
  return $zeroResults;
};

var countVisible = function countVisible($checkboxes) {
  return $checkboxes.filter(':visible').length;
};

var checkZeroResults = function checkZeroResults($checkboxes, $zeroResults) {
  if (countVisible($checkboxes) === 0) {
    $zeroResults.removeClass('u-hide');
  } else {
    $zeroResults.addClass('u-hide');
  }
};
/**
 * Initializes productFilterSearch
 * @param {HTMLElement} el - filter container
 * @param {Object} options - Options used for wiring up the plugin
 * @see DEFAULTS
 */


function productFilterSearch(container) {
  var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
  var $container = __WEBPACK_IMPORTED_MODULE_0_jquery___default()(container);
  var opts = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_styleguide_lib_merge_options__["a" /* default */])(DEFAULTS, options, $container);
  var $checkboxes = $container.find('input[type="checkbox"]');
  var checkboxData = createData($checkboxes);
  var $searchField = $container.find('input[type="text"');
  var $zeroResults = createZeroResults($container, opts);
  $container.productFilterCount();
  __WEBPACK_IMPORTED_MODULE_0_jquery___default()('[aria-controls=alldesigners]').on('click', function () {
    __WEBPACK_IMPORTED_MODULE_0_jquery___default()('#alldesigners').formField();
  });
  $searchField.on('input', function () {
    var matches = findMatches($searchField.val(), checkboxData);
    $checkboxes.each(function (index, checkbox) {
      var $checkbox = __WEBPACK_IMPORTED_MODULE_0_jquery___default()(checkbox);
      var $checkboxContainer = $checkbox.closest('.accordion__height-cap');
      var $label = $checkboxContainer.find('.checkbox__label'); // show checkbox option

      if (matches.includes(index)) {
        $checkboxContainer.removeClass('u-hide');

        if ($searchField.val() === '') {
          $label.html($checkbox.data('data-original-text'));
        } else {
          var highlight = highlightText($searchField.val(), $checkbox.data('data-original-text'));
          $label.html(highlight);
        } //  hide checkbox option

      } else {
        $checkboxContainer.addClass('u-hide');
      }
    });
    checkZeroResults($checkboxes, $zeroResults);
  });
}
__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__lib_register_jquery_plugin__["a" /* default */])(PLUGIN_NAME, productFilterSearch);

/***/ }),

/***/ 197:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_lodash_throttle__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_lodash_throttle___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_lodash_throttle__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_styleguide_lib_props__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_jquery__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_jquery___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_jquery__);



var $viewPrevLoading = __WEBPACK_IMPORTED_MODULE_2_jquery___default()(".js-view-prev-loading");
var $viewMoreLoading = __WEBPACK_IMPORTED_MODULE_2_jquery___default()(".js-view-more-loading");
var $viewMoreBtn = __WEBPACK_IMPORTED_MODULE_2_jquery___default()(".js-view-more-btn");
var $viewPrevBtn = __WEBPACK_IMPORTED_MODULE_2_jquery___default()(".js-view-prev-btn");
var $plpProductsContents = __WEBPACK_IMPORTED_MODULE_2_jquery___default()("#plp-products-contents");
var $showProductsCount = __WEBPACK_IMPORTED_MODULE_2_jquery___default()("#showing-items-count");
var $statusMessage;
var isABTest3336 = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_styleguide_lib_props__["a" /* get */])('abtests.ab3336', false);
__WEBPACK_IMPORTED_MODULE_2_jquery___default()(function () {
  // Only execute code if test is active on page
  if (isABTest3336 === false) return false;
  var currentPage = parseInt(__WEBPACK_IMPORTED_MODULE_2_jquery___default()('.js-plp-prod-wrapper>ul').data('currentPage'));
  var pagesLoaded = {
    min: currentPage,
    max: currentPage
  };
  var isFetching = false;
  var nextPagePromise = null;
  var prevPagePromise = null;
  var nextPageData = null;
  var prevPageData = null;
  var userClickedNextCTABeforeDataLoaded = false;
  var lastScrollTop = 0; // Any time a plp filter is selected, we want to clear
  // the data that was prefetched

  __WEBPACK_IMPORTED_MODULE_2_jquery___default()(document).on("filterSelected", function () {
    nextPagePromise = null;
    prevPagePromise = null;
    nextPageData = null;
    prevPageData = null;
    currentPage = 1;
    pagesLoaded = {
      min: currentPage,
      max: currentPage
    };
  });

  function updateURL(page) {
    var url = new URL(window.location.href);
    url.searchParams.set('pageNum', page);
    window.history.pushState({}, '', url);
  } // New function to handle product clicks


  function handleProductClick(e) {
    e.preventDefault();
    var $productLink = __WEBPACK_IMPORTED_MODULE_2_jquery___default()(e.currentTarget);
    var $productItem = $productLink.closest('li'); // Get the parent li element

    var productId = $productItem.attr('id');
    var $parentList = $productItem.closest('ul');
    var currentPage = $parentList.data('currentPage'); // Use the clicked link's href directly since e.currentTarget is now the link

    var productUrl = $productLink.attr('href'); // Update URL with both page and product ID

    var url = new URL(window.location.href);
    url.searchParams.set('pageNum', currentPage);
    url.searchParams.set('product', productId);
    window.history.pushState({}, '', url); // Navigate to product page

    window.location.href = productUrl;
  } // Attach click handler to all product items (existing and future)


  __WEBPACK_IMPORTED_MODULE_2_jquery___default()(document).on('click', '.js-plp-prod-wrapper .js-plp-pdp-link, .js-plp-prod-wrapper .js-plp-pdp-link2', handleProductClick);

  function fetchPage(page) {
    return new Promise(function (resolve, reject) {
      var url = new URL(window.location.href);
      url.searchParams.set('pageNum', page);
      var data = __WEBPACK_IMPORTED_MODULE_2_jquery___default.a.param({
        url: url.href,
        isMen: __WEBPACK_IMPORTED_MODULE_2_jquery___default()('#isMen').length ? __WEBPACK_IMPORTED_MODULE_2_jquery___default()('#isMen').val() : 'false'
      });
      __WEBPACK_IMPORTED_MODULE_2_jquery___default.a.ajax({
        url: '/content/products/filtered-plp-contents/',
        data: data,
        dataType: 'json',
        type: 'POST',
        success: function success(data) {
          var $pageData = __WEBPACK_IMPORTED_MODULE_2_jquery___default()(data.plpMarkup);
          resolve($pageData);
        },
        error: function error() {
          reject("Error fetching products.");
        }
      });
    });
  }

  function preloadNextPage() {
    if (isFetching || nextPagePromise) return;
    var nextPage = pagesLoaded.max + 1;
    isFetching = true;
    nextPagePromise = fetchPage(nextPage).then(function (data) {
      nextPageData = data;
      return data;
    })["finally"](function () {
      isFetching = false;
      if (userClickedNextCTABeforeDataLoaded) displayNextPage();
    });
  }

  function loadPrevPage() {
    if (isFetching || prevPagePromise || pagesLoaded.min === 1) return; // Store the current height before adding new content

    var oldHeight = document.body.scrollHeight;
    var prevPage = pagesLoaded.min - 1;
    isFetching = true;
    prevPagePromise = fetchPage(prevPage).then(function (data) {
      prevPageData = data;
      return data;
    })["finally"](function () {
      isFetching = false;
      displayPrevPage();
      var $element = __WEBPACK_IMPORTED_MODULE_2_jquery___default()('.js-plp-prod-wrapper').first();

      if ($element.length > 0) {
        window.scrollTo({
          top: $element[0].scrollHeight
        });
      }
    }); // a11y announcement

    $statusMessage.html('page is loading');
  }

  function displayNextPage() {
    if (!nextPagePromise || !nextPageData) return;
    userClickedNextCTABeforeDataLoaded = false;
    $plpProductsContents.append(nextPageData);
    pagesLoaded.max += 1;
    nextPageData = null;
    nextPagePromise = null;
    $viewMoreLoading.addClass('u-hide');
    $viewMoreBtn.removeClass('u-hide');
    window.reloadBindJs && window.reloadBindJs(); // -----
    // a11y
    // -----

    var $lastSection = $plpProductsContents.find('section').last(); // Update button CTA aria-label

    var $productList = $lastSection.find(".products-grid");
    var currentPage = $productList.data('currentPage');
    var totalPages = $productList.data('totalPages');
    var containerId = $productList.data('id');
    window.bindHeartItems && bindHeartItems("#".concat(containerId));
    var totalPageCount = parseInt(totalPages);

    if (pagesLoaded.max >= totalPageCount) {
      $viewMoreBtn.addClass('u-hide');
    }

    var productsCount = __WEBPACK_IMPORTED_MODULE_2_jquery___default()('.js-plp-prod-wrapper').find('li.js-plp-container').length;
    $showProductsCount.html(productsCount);
    $viewMoreBtn.attr('aria-label', "Load Next Page (Page ".concat(currentPage + 1, " of ").concat(totalPages, ")")); // announcement

    $statusMessage.html('page has loaded'); // focus on last section

    $lastSection.attr('tabindex', '-1');
    $lastSection[0].focus({
      preventScroll: true
    });
  }

  function displayPrevPage() {
    if (!prevPagePromise || !prevPageData) return;
    pagesLoaded.min -= 1;

    if (pagesLoaded.min > 1) {
      $viewPrevBtn.show();
    }

    $plpProductsContents.prepend(prevPageData);
    $viewPrevLoading.addClass('u-hide');
    prevPageData = null;
    prevPagePromise = null; // reinitialize events

    window.reloadBindJs && window.reloadBindJs(); // -----
    // a11y
    // -----

    var $firstSection = $plpProductsContents.find('section').first(); // Update button CTA aria-label

    var $productList = $firstSection.find(".products-grid");
    var currentPage = $productList.data('currentPage');
    $viewPrevBtn.attr('aria-label', "Load Previous Page (Page ".concat(currentPage - 1, ")"));
    var productsCount = __WEBPACK_IMPORTED_MODULE_2_jquery___default()('.js-plp-prod-wrapper').find('li.js-plp-container').length;
    $showProductsCount.html(productsCount); // announcement

    $statusMessage.html('page has loaded'); // focus on first section

    $firstSection.attr('tabindex', '-1');
    $firstSection[0].focus({
      preventScroll: true
    });
  }

  function updateURLBasedOnScroll() {
    var viewportMiddle = window.scrollY + window.innerHeight / 2;
    var pages = __WEBPACK_IMPORTED_MODULE_2_jquery___default()(".js-plp-prod-wrapper>ul");
    var closestPage = null;
    var closestDistance = Infinity;
    pages.each(function () {
      var pageElement = __WEBPACK_IMPORTED_MODULE_2_jquery___default()(this);
      var pageMiddle = pageElement.offset().top + pageElement.height() / 2;
      var distance = Math.abs(viewportMiddle - pageMiddle);

      if (distance < closestDistance) {
        closestDistance = distance;
        closestPage = pageElement;
      }
    });
    var pageNumber = closestPage.data('currentPage');
    updateURL(pageNumber);
  } // Handle "view more" button click


  $viewMoreBtn.on("click", function () {
    if (nextPagePromise && nextPageData) {
      displayNextPage();
    } else {
      userClickedNextCTABeforeDataLoaded = true;
      $viewMoreBtn.addClass('u-hide');
      $viewMoreLoading.removeClass('u-hide');
    }

    if (typeof window.logEngagement == "function") {
      window.logEngagement(window.location.href, 'View More', 'Click');
    }
  }); // Handle "Previous" button click

  $viewPrevBtn.on("click", function () {
    if (!isFetching && pagesLoaded.min > 1) {
      $viewPrevBtn.hide();
      $viewPrevLoading.removeClass('u-hide');
      loadPrevPage();

      if (typeof window.logEngagement == "function") {
        window.logEngagement(window.location.href, 'View Previous', 'Click');
      }
    }
  });
  var throttleUpdateURL = __WEBPACK_IMPORTED_MODULE_0_lodash_throttle___default()(updateURLBasedOnScroll, 100);
  /**
    * onScroll handle preload for "next page"
  **/

  __WEBPACK_IMPORTED_MODULE_2_jquery___default()(window).on("scroll", function () {
    var st = __WEBPACK_IMPORTED_MODULE_2_jquery___default()(window).scrollTop();
    var windowHeight = __WEBPACK_IMPORTED_MODULE_2_jquery___default()(window).height();
    var docHeight = __WEBPACK_IMPORTED_MODULE_2_jquery___default()(document).height();
    throttleUpdateURL();
    var isScrollingDown = st > lastScrollTop;
    lastScrollTop = st; // Next Page Preload Logic

    if (isScrollingDown) {
      if (!isFetching && !nextPagePromise) {
        var lastPage = __WEBPACK_IMPORTED_MODULE_2_jquery___default()(".js-plp-prod-wrapper").last();
        var lastPageOffset = lastPage.offset().top + lastPage.outerHeight();
        var triggerPoint = lastPageOffset - lastPage.outerHeight() * (1 / 3);

        if (st + windowHeight > triggerPoint) {
          preloadNextPage();
        }
      }
    }
  });
  /**
   * Product page navigation enhancement
   * 
   * This script handles the case when a user clicks the back button after viewing a product:
   * 1. Extracts the product ID from URL parameters
   * 2. Removes the product parameter from URL (for cleaner history)
   * 3. Scrolls to the product in the product listing page if it exists
   * 
   * This improves UX by maintaining context when navigating back from product details.
   */

  function backButtonPageNavigation() {
    // Extract product ID from URL query parameters
    var url = new URL(window.location.href);
    var productId = url.searchParams.get('product'); // Clean up URL by removing the product parameter

    url.searchParams["delete"]('product');
    history.replaceState({}, '', url); // If product ID exists and the corresponding element is found,
    // scroll to center it in the viewport

    if (productId && __WEBPACK_IMPORTED_MODULE_2_jquery___default()('#' + productId).length) {
      if ('scrollRestoration' in history) history.scrollRestoration = 'manual';
      __WEBPACK_IMPORTED_MODULE_2_jquery___default()('#' + productId)[0].scrollIntoView({
        block: 'center'
      });
    }
  }

  function appendSRStatusElement() {
    $statusMessage = __WEBPACK_IMPORTED_MODULE_2_jquery___default()("<div id=\"view-more-status-message\" aria-live=\"polite\" role=\"status\" class=\"u-screen-reader\"></div>");
    __WEBPACK_IMPORTED_MODULE_2_jquery___default()('body').append($statusMessage);
  }

  appendSRStatusElement();
  backButtonPageNavigation();
});

/***/ }),

/***/ 198:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export PLUGIN_NAME */
/* unused harmony export default */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_jquery__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_jquery___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_jquery__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_styleguide_lib_register_jquery_plugin__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__pdp_add_to_bag__ = __webpack_require__(12);
/**
 * Handles add to bag button for PLP's (Supported only by favorites and BI best sellers)
 *
 * @module plpAddToBag
 */



var PLUGIN_NAME = 'plpAddToBag';

var addToBag = function addToBag($el) {
  var isOneSize = $el.data("oneSize");
  var code = $el.data('code');
  var size = $el.data('size');
  var swatchName = 'color_' + code;
  var radioBtn = __WEBPACK_IMPORTED_MODULE_0_jquery___default()('input[name=\'' + swatchName + '\']:checked');

  if (radioBtn && radioBtn.length) {
    code = radioBtn.closest('.js-plp-swatch').data('code');
  }

  if (isOneSize) {
    size = 'all';
  } else if (!size) {
    var $sizeEl = $el.parent().find('.js-select-size');
    $sizeEl.data('addToBag', true);
    $sizeEl.data('code', code);
    var $selectSizeTrigger = $sizeEl.find('.js-select-size-trigger');
    $selectSizeTrigger.click();
  }

  if (size) {
    __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__pdp_add_to_bag__["a" /* addToBag */])(code, size);
    $el.data('size', ''); // reset size so dropdown can be opened again
  }
};
/**
 * Add To Bag Functionality for PLP (Supported on Favorites/BI Best Seller Page atm)
 *
 * @param {jQuery} el - targeting the element of the plp list
 * @param {Object} options - Options used for wiring up the sizeSelection
 * @see DEFAULTS
 */


function plpAddToBag(el) {
  var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
  var $el = __WEBPACK_IMPORTED_MODULE_0_jquery___default()(el);
  $el.on('click', function (e) {
    e.preventDefault();
    addToBag($el);
  });
}
__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_styleguide_lib_register_jquery_plugin__["a" /* default */])(PLUGIN_NAME, plpAddToBag);

/***/ }),

/***/ 199:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_jquery__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_jquery___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_jquery__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_lodash_get__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_lodash_get___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_lodash_get__);


var SELECTORS = {
  TOGGLE_CONTAINER: '.js-toggle-container',
  TOGGLE_DROPDOWN: '.js-toggle-dropdown'
};
/* harmony default export */ __webpack_exports__["a"] = (function () {
  var categoryHeader = __WEBPACK_IMPORTED_MODULE_1_lodash_get___default()(window, 'rcProps.trigger.plp.categoryHeader', false);

  if (categoryHeader === true || categoryHeader === 'true') {
    var $categoryDropdown = __WEBPACK_IMPORTED_MODULE_0_jquery___default()(SELECTORS.TOGGLE_CONTAINER).find(SELECTORS.TOGGLE_DROPDOWN);

    if ($categoryDropdown.length) {
      $categoryDropdown.click();
    }
  }
});
;

/***/ }),

/***/ 200:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_jquery__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_jquery___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_jquery__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_lodash_get__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_lodash_get___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_lodash_get__);


/* harmony default export */ __webpack_exports__["a"] = (function () {
  var favBrand = __WEBPACK_IMPORTED_MODULE_1_lodash_get___default()(window, 'rcProps.trigger.plp.favBrand', '');

  if (favBrand === true || favBrand === 'true') {
    var addDesignerButton = __WEBPACK_IMPORTED_MODULE_0_jquery___default()('#js-btt-fixed-target > span');
    addDesignerButton.click();
  }
});

/***/ }),

/***/ 201:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_jquery__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_jquery___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_jquery__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_lodash_get__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_lodash_get___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_lodash_get__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_modules_heart_product__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__chrome_header_load_favorite_count__ = __webpack_require__(69);




/* harmony default export */ __webpack_exports__["a"] = (function (waitForFavoriteCount) {
  var favProduct = __WEBPACK_IMPORTED_MODULE_1_lodash_get___default()(window, 'rcProps.trigger.plp.favProduct', '');
  var $product = __WEBPACK_IMPORTED_MODULE_0_jquery___default()('#plp-products-contents').find(".favorite-button[data-pcode='".concat(favProduct, "']"));
  var productInPage = $product.length;
  var productIsFavorite = $product.hasClass('favorite-button--active');
  var scrollBuffer = 30;

  if (favProduct !== '') {
    var waitForFavoriteCountPromise = waitForFavoriteCount === undefined ? __WEBPACK_IMPORTED_MODULE_3__chrome_header_load_favorite_count__["a" /* default */] : waitForFavoriteCount;

    if (productInPage) {
      waitForFavoriteCountPromise.then(function () {
        if (!productIsFavorite) {
          $product.click();
        }

        __WEBPACK_IMPORTED_MODULE_0_jquery___default()([document.documentElement, document.body]).scrollTop($product.offset().top - scrollBuffer);
      });
    } else {
      __WEBPACK_IMPORTED_MODULE_3__chrome_header_load_favorite_count__["a" /* default */].then(function () {
        __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2_modules_heart_product__["a" /* default */])('#pageItems', '.fav-item', favProduct);
      });
    }
  }
});
;

/***/ }),

/***/ 202:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_jquery__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_jquery___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_jquery__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_lodash_get__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_lodash_get___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_lodash_get__);


/* harmony default export */ __webpack_exports__["a"] = (function () {
  var openFilter = __WEBPACK_IMPORTED_MODULE_1_lodash_get___default()(window, 'rcProps.trigger.plp.openFilter', false);

  if (openFilter === true || openFilter === 'true') {
    __WEBPACK_IMPORTED_MODULE_0_jquery___default()('.js-amp-filter').click();
  }
});
;

/***/ }),

/***/ 203:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_jquery__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_jquery___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_jquery__);

var BANNER_TARGET_CLASS = '.js-cpl-banner';
var ITEM_SELECTOR = 'a.pill-button';
var ACTIVE_CLASS = 'active';
var CPL_ID_PARAM = 'cplid';
/* harmony default export */ __webpack_exports__["a"] = (function () {
  var urlParams = new URLSearchParams(window.location.search);
  var cplId = urlParams.get(CPL_ID_PARAM);
  __WEBPACK_IMPORTED_MODULE_0_jquery___default()(ITEM_SELECTOR, __WEBPACK_IMPORTED_MODULE_0_jquery___default()(BANNER_TARGET_CLASS)).each(function (i, el) {
    var $anchor = __WEBPACK_IMPORTED_MODULE_0_jquery___default()(el);

    if ($anchor.length) {
      var href = $anchor.attr('href');
      var hrefParts = href ? href.split('?') : [];
      var anchorUrlParams = new URLSearchParams(hrefParts.length === 2 ? '?' + hrefParts[1] : '');
      var anchorCplId = anchorUrlParams.get(CPL_ID_PARAM);

      if (anchorCplId === cplId) {
        $anchor.addClass(ACTIVE_CLASS);
      }
    }
  });
});

/***/ }),

/***/ 204:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_jquery__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_jquery___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_jquery__);
/**
 * Handles tab functionality for Loyalty Favorites LP
 *
 * @module loyaltyFavorites
 */

__WEBPACK_IMPORTED_MODULE_0_jquery___default()(function () {
  // Should only run if we're on a loyalty favorites LP
  if (__WEBPACK_IMPORTED_MODULE_0_jquery___default()('.loyalty-favorites').length) {
    var waitForFirstRowImages = function waitForFirstRowImages() {
      var $images = __WEBPACK_IMPORTED_MODULE_0_jquery___default()('#loyalty-favorites-content .n-block-grid--2 li img');
      if ($images.length <= 4) return; // Select the first four images (2 rows of 2)

      var $firstRowImages = __WEBPACK_IMPORTED_MODULE_0_jquery___default()('#loyalty-favorites-content .n-block-grid--2 li:lt(4) img');
      var imagesLoaded = 0;
      $firstRowImages.each(function () {
        if (this.complete) {
          // Check if image is already cached
          imagesLoaded++;

          if (imagesLoaded === $firstRowImages.length) {
            addHeartEvent();
          }
        } else {
          __WEBPACK_IMPORTED_MODULE_0_jquery___default()(this).on('load', function () {
            imagesLoaded++;

            if (imagesLoaded === $firstRowImages.length) {
              addHeartEvent();
            }
          });
        }

        __WEBPACK_IMPORTED_MODULE_0_jquery___default()(this).on('error', function () {
          imagesLoaded++;

          if (imagesLoaded === $firstRowImages.length) {
            addHeartEvent();
          }
        });
      }); // Handle case where there are no images in the first row

      if ($firstRowImages.length === 0) {
        addHeartEvent();
      }
    };

    var addHeartEvent = function addHeartEvent() {
      if (typeof window.bindHeartEvent === 'function') {
        window.bindHeartEvent(__WEBPACK_IMPORTED_MODULE_0_jquery___default()('#loyalty-favorites-content .js-favorite-button'));
      }
    };

    var $tabs = __WEBPACK_IMPORTED_MODULE_0_jquery___default()('.loyalty-favorites__tabs');
    var $content = __WEBPACK_IMPORTED_MODULE_0_jquery___default()('#loyalty-favorites-content');
    var $tabAlert = __WEBPACK_IMPORTED_MODULE_0_jquery___default()('#loyalty-tab-alert');
    var $products = $content.find('.loyalty-favorites__products');
    var ACTIVE_CLASS = 'loyalty-favorites__tab--active';
    $tabs.on('click', '[data-tab]', function () {
      var tab = __WEBPACK_IMPORTED_MODULE_0_jquery___default()(this).data('tab');
      var $clickedTab = __WEBPACK_IMPORTED_MODULE_0_jquery___default()(this).closest('.loyalty-favorites__tab');

      if ($clickedTab.hasClass(ACTIVE_CLASS)) {
        return;
      }

      $tabs.find('.loyalty-favorites__tab').removeClass(ACTIVE_CLASS).attr('aria-selected', 'false');
      $clickedTab.addClass(ACTIVE_CLASS).attr('aria-selected', 'true');
      __WEBPACK_IMPORTED_MODULE_0_jquery___default.a.ajax({
        url: "ajax/".concat(tab, ".jsp"),
        dataType: 'html',
        success: function success(html) {
          $products.html(html);
          waitForFirstRowImages();
          $products.find('.js-lazy-image').lazy({
            effect: 'fadeIn',
            effectTime: 300
          });

          if (tab === 'vip') {
            tab = tab.toUpperCase();
          }

          $tabAlert.text("".concat(tab, " tier product listing loaded"));
        },
        error: function error(err) {
          console.error("Error loading Loyalty Favorites HTML content", err);
        }
      });
    });
  }
});

/***/ }),

/***/ 205:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export SELECTORS */
/* harmony export (immutable) */ __webpack_exports__["a"] = init;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_jquery__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_jquery___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_jquery__);

var SELECTORS = {
  addToBagDropDown: '.js-add-to-bag-select',
  clearOldFav: '#js-clear-old-fav',
  closePopupBtn: '.js-close-limit-popup',
  sendMyFavBtn: '#js-send-my-fav'
};
function init() {
  var isGuest = __WEBPACK_IMPORTED_MODULE_0_jquery___default()('#limitPopup').data('isGuest');
  var productSize = __WEBPACK_IMPORTED_MODULE_0_jquery___default()('#limitPopup').data('productSize');

  if (isGuest && productSize > 200) {
    __WEBPACK_IMPORTED_MODULE_0_jquery___default()('#guestLimitPop').addClass('u-block');
  } else if (!isGuest && productSize > 2000) {
    __WEBPACK_IMPORTED_MODULE_0_jquery___default()('#userLimitPop').addClass('u-block');
  }

  __WEBPACK_IMPORTED_MODULE_0_jquery___default()(SELECTORS.addToBagDropDown).change(addToBagFromMyFav);
  __WEBPACK_IMPORTED_MODULE_0_jquery___default()(SELECTORS.clearOldFav).click(clearOldFavItems);
  __WEBPACK_IMPORTED_MODULE_0_jquery___default()(SELECTORS.closePopupBtn).click(closeLimitLightBox);
  initPopUp();
  initSendFavorites();
  __WEBPACK_IMPORTED_MODULE_0_jquery___default()(SELECTORS.sendMyFavBtn).click(sendMyFavoriteEmail);
}

function sendMyFavoriteEmail() {
  if (typeof logEngagement === 'function') {
    logEngagement(window.location.href, 'share my favorites', 'submit');
  }

  var recipient = __WEBPACK_IMPORTED_MODULE_0_jquery___default()('#email-1').val();

  if (recipient.length > 0 && recipient.indexOf('@') <= 0) {
    showErrorMsg(1);
    return;
  }

  var recipient2 = __WEBPACK_IMPORTED_MODULE_0_jquery___default()('#email-2').val();

  if (recipient2.indexOf('@') > 0) {
    recipient += "," + recipient2;
  } else if (recipient2.length > 0) {
    showErrorMsg(2);
    return;
  }

  var recipient3 = __WEBPACK_IMPORTED_MODULE_0_jquery___default()('#email-3').val();

  if (recipient3.indexOf('@') > 0) {
    recipient += "," + recipient3;
  } else if (recipient3.length > 0) {
    showErrorMsg(3);
    return;
  }

  var recipient4 = __WEBPACK_IMPORTED_MODULE_0_jquery___default()('#email-4').val();

  if (recipient4.indexOf('@') > 0) {
    recipient += "," + recipient4;
  } else if (recipient4.length > 0) {
    showErrorMsg(4);
    return;
  }

  var recipient5 = __WEBPACK_IMPORTED_MODULE_0_jquery___default()('#email-5').val();

  if (recipient5.indexOf('@') > 0) {
    recipient += "," + recipient5;
  } else if (recipient5.length > 0) {
    showErrorMsg(5);
    return;
  }

  if (recipient.length == 0) {
    showErrorMsg(1);
    return;
  }

  var data = __WEBPACK_IMPORTED_MODULE_0_jquery___default.a.param({
    email: recipient // comment: $('#comment').val()

  });
  __WEBPACK_IMPORTED_MODULE_0_jquery___default.a.ajax({
    type: 'GET',
    url: '/r/ajax/SendMyFavoriteEmail.jsp',
    data: data,
    success: function success(responseText) {
      __WEBPACK_IMPORTED_MODULE_0_jquery___default.a.modal({
        open: "modal-thankyou",
        triggerOpen: true,
        onComplete: function onComplete() {
          __WEBPACK_IMPORTED_MODULE_0_jquery___default()('#resultMessage').html(responseText);
        }
      });
    }
  });
}

function showErrorMsg(num) {
  __WEBPACK_IMPORTED_MODULE_0_jquery___default()('#error-' + num).show();
  __WEBPACK_IMPORTED_MODULE_0_jquery___default()('#email-' + num).addClass('u-error').keydown(function () {
    if (__WEBPACK_IMPORTED_MODULE_0_jquery___default()(this).val()) {
      __WEBPACK_IMPORTED_MODULE_0_jquery___default()('#email-' + num).removeClass('u-error').off('keydown');
      __WEBPACK_IMPORTED_MODULE_0_jquery___default()('#error-' + num).hide();
    }
  });
}

function addToBagFromMyFav() {
  var sizeOption = __WEBPACK_IMPORTED_MODULE_0_jquery___default()(this).find("option:selected");
  var code = __WEBPACK_IMPORTED_MODULE_0_jquery___default()(this).data('code');
  var productNameNoBrandNoColor = __WEBPACK_IMPORTED_MODULE_0_jquery___default()(this).data('productName');
  var size = sizeOption.val();

  if (size == '' || code == '') {
    return;
  }

  if (sizeOption.data("showNotifyMe")) {
    var url = "/r/mobile/BISAndSO.jsp?code=" + code;
    location.href = url;
    return;
  }

  var data = __WEBPACK_IMPORTED_MODULE_0_jquery___default.a.param({
    code: code,
    size: size,
    qty: 1,
    csrfHash: window.rcProps.csrfHash,
    sectionURL: __WEBPACK_IMPORTED_MODULE_0_jquery___default()(this).data('sectionurl'),
    sessionID: __WEBPACK_IMPORTED_MODULE_0_jquery___default()(this).data('sessionid')
  });

  if (typeof window.gaq != 'undefined') {
    window._gaq.push(['_trackEvent', 'Product', 'Add to Cart', code + ' | ' + productNameNoBrandNoColor + ' | 1']);
  }

  __WEBPACK_IMPORTED_MODULE_0_jquery___default.a.post("AddToCart.jsp", data, function () {
    __WEBPACK_IMPORTED_MODULE_0_jquery___default.a.when(window.insertPageTrackForMobile(true, code)).done(function () {
      var param = __WEBPACK_IMPORTED_MODULE_0_jquery___default.a.param({
        code: code
      });
      __WEBPACK_IMPORTED_MODULE_0_jquery___default.a.get("/r/mobile/dialog/AddToBagPopup.jsp", param, function (html) {
        __WEBPACK_IMPORTED_MODULE_0_jquery___default()("#add-to-bag-popup").html(html);
        __WEBPACK_IMPORTED_MODULE_0_jquery___default()("#add-to-bag-popup").fadeIn();
        __WEBPACK_IMPORTED_MODULE_0_jquery___default()("#add-to-bag-popup").find(".view-bag-btn").click(function () {
          window.location = "/r/mobile/ShoppingBag.jsp";
        });
        __WEBPACK_IMPORTED_MODULE_0_jquery___default()("#add-to-bag-popup").find(".continue-shopping-btn").click(function () {
          __WEBPACK_IMPORTED_MODULE_0_jquery___default()("#add-to-bag-popup").fadeOut();
        });
        __WEBPACK_IMPORTED_MODULE_0_jquery___default()('body,html').animate({
          scrollTop: 0
        }, 'fast');
        __WEBPACK_IMPORTED_MODULE_0_jquery___default.a.ajax({
          type: "POST",
          url: "/r/mobile/AjaxUserShoppingBag.jsp",
          success: function success(response) {
            var responseObj = eval('(' + response + ')');
            __WEBPACK_IMPORTED_MODULE_0_jquery___default()("#shopping_bag_count").html(responseObj);
          }
        });
      });
    });
  });
}

function initPopUp() {
  var popup, popupAlt;
  __WEBPACK_IMPORTED_MODULE_0_jquery___default()(".js-inpopup-toggle").on("click", function () {
    popup = __WEBPACK_IMPORTED_MODULE_0_jquery___default()(__WEBPACK_IMPORTED_MODULE_0_jquery___default()(this).attr("data-inpopup"));
    popupAlt = __WEBPACK_IMPORTED_MODULE_0_jquery___default()(".js-inpopup-alt-content");
    popup.show();
    popupAlt.hide();
  });
  __WEBPACK_IMPORTED_MODULE_0_jquery___default()(".js-inpopup-close-btn").on("click", closeInpopup);

  function closeInpopup() {
    popup.hide();
    popupAlt.show();
  }
}

function initSendFavorites() {
  var favoritesSubmit = __WEBPACK_IMPORTED_MODULE_0_jquery___default()(".js-submit-favorites");
  favoritesSubmit.on("click", function (e) {
    e.preventDefault();
    __WEBPACK_IMPORTED_MODULE_0_jquery___default()("#js-fav-share-popup-form").hide();
    __WEBPACK_IMPORTED_MODULE_0_jquery___default()("#js-fav-share-popup-thanks").show();
  });
}

function clearOldFavItems() {
  __WEBPACK_IMPORTED_MODULE_0_jquery___default.a.ajax({
    type: 'GET',
    url: '/r/ajaxHeartProduct.jsp?action_T=clearolditems',
    success: function success() {
      location.reload();
    }
  });
}

function closeLimitLightBox() {
  var elemId = __WEBPACK_IMPORTED_MODULE_0_jquery___default()(this).data('popupId');
  __WEBPACK_IMPORTED_MODULE_0_jquery___default()('#' + elemId).removeClass('u-block');
}

/***/ }),

/***/ 206:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export PLUGIN_NAME */
/* unused harmony export SS_TRIGGER_CLASS */
/* unused harmony export DEFAULTS */
/* unused harmony export default */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_jquery__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_jquery___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_jquery__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_styleguide_lib_register_jquery_plugin__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_styleguide_lib_merge_options__ = __webpack_require__(2);
/**
 * Handles the plp lazy loading and back button functionality
 * Lazy loads the images once window loads.
 * Fixes the correct page position if going back to plp.
 * @module sizeSelection
 */



var PLUGIN_NAME = 'sizeSelection';
var SS_TRIGGER_CLASS = '.js-select-size-trigger';
var DEFAULTS = {
  sessionName: '',
  loadAfterCallback: function loadAfterCallback() {}
};

var showConfirmation = function showConfirmation(opts, hasError) {
  var saveSizeConfirmPath = opts.saveSizeConfirmPath;
  __WEBPACK_IMPORTED_MODULE_0_jquery___default.a.modal({
    url: "".concat(saveSizeConfirmPath).concat(hasError),
    triggerOpen: true,
    type: 'notification'
  });
};

var updateSizeToDb = function updateSizeToDb($el, opts, sizeValue) {
  if (sizeValue) {
    var updateSizePath = opts.updateSizePath,
        code = opts.code;
    __WEBPACK_IMPORTED_MODULE_0_jquery___default.a.ajax({
      url: "".concat(updateSizePath).concat(sizeValue),
      type: "POST",
      success: function success(ret) {
        if (ret.success) {
          var $preorderCta = __WEBPACK_IMPORTED_MODULE_0_jquery___default()("#preorder-cta-".concat(code));
          var $addToBagCta = __WEBPACK_IMPORTED_MODULE_0_jquery___default()("#add-to-bag-cta-".concat(code));
          var $addToBagBtn = __WEBPACK_IMPORTED_MODULE_0_jquery___default()("#add-to-bag-".concat(code));
          var $outOfStockBtn = __WEBPACK_IMPORTED_MODULE_0_jquery___default()("#outOfStock_".concat(code));

          if ($outOfStockBtn.length) {
            $addToBagBtn.show();
            $outOfStockBtn.remove();
          }

          if (ret.isPreorder) {
            $preorderCta.show();
            $addToBagCta.hide();
          } else {
            $preorderCta.hide();
            $addToBagCta.show();
          }

          showConfirmation(opts, false);

          if (typeof logEngagementWithDetails === "function") {
            logEngagementWithDetails(window.location.href, 'favorites save your size', 'SaveSize', "size=".concat(sizeValue, ", code=").concat(code));
          }
        }
      }
    });
  } else {
    showConfirmation(opts, true);
  }
};

var setUpdateSizeListener = function setUpdateSizeListener($el, $saveSizeTrigger, opts) {
  __WEBPACK_IMPORTED_MODULE_0_jquery___default()('input[name="fav-size-selection"]').on('change', function () {
    var sizeSelected = __WEBPACK_IMPORTED_MODULE_0_jquery___default()(this).val();
    var isOneLeft = __WEBPACK_IMPORTED_MODULE_0_jquery___default()(this).data('isOneLeft');
    var code = opts.code,
        addToBag = opts.addToBag,
        updateSizePath = opts.updateSizePath,
        hideCopy = opts.hideCopy;
    var hideClass = opts.hideCopy ? "class=\"u-hide\"" : "";
    $saveSizeTrigger.html("<span id=\"".concat(code, "-fav-size-value\" data-size=\"").concat(sizeSelected, "\" ").concat(hideClass, ">Size: ").concat(sizeSelected, "</span>")); // update size copy

    var $soldOut = $el.find('.js-saved-size-sold-out');
    var $oneLeft = $el.find('.js-saved-size-one-left');

    if ($soldOut.length) {
      $soldOut.hide();
    }

    if (isOneLeft !== undefined && $oneLeft.length) {
      if (isOneLeft) {
        $oneLeft.show();
      } else {
        $oneLeft.hide();
      }
    }

    if (updateSizePath) {
      updateSizeToDb($el, opts, sizeSelected);
    }

    if (addToBag === 'true' || addToBag === true) {
      var $addToBag = __WEBPACK_IMPORTED_MODULE_0_jquery___default()("#add-to-bag-".concat(code));

      if ($addToBag.length) {
        $addToBag.data('size', sizeSelected);
        $addToBag.click();
      }
    }
  });
};

var getSizes = function getSizes($el, $saveSizeTrigger, opts) {
  opts.addToBag = $el.data('addToBag');
  var sizePath = window.rcProps.sizeMarkupUri + '?code=' + $el.data('code');
  $el.data('addToBag', 'false');
  __WEBPACK_IMPORTED_MODULE_0_jquery___default.a.modal({
    url: sizePath,
    triggerOpen: true,
    type: "toast",
    addModifierClass: 'modal--toast-sizes',
    overlayClose: false,
    returnFocus: $el.find('.js-select-size-trigger'),
    onComplete: function onComplete() {
      setUpdateSizeListener($el, $saveSizeTrigger, opts);

      if (typeof window.bindSizeGuideEvent() === 'function') {
        window.bindSizeGuideEvent();
      }
    }
  });

  if (typeof window.showBisOrSo !== "function") {
    window.showBisOrSo = function (code) {
      __WEBPACK_IMPORTED_MODULE_0_jquery___default.a.modal({
        url: window.rcProps.backInStockSpecialOrderHref + "&code=" + code,
        type: "full",
        open: null,
        cache: false,
        overlayClose: true,
        triggerOpen: true,
        returnFocus: $el.find('.js-select-size-trigger'),
        onComplete: function onComplete() {
          __WEBPACK_IMPORTED_MODULE_0_jquery___default()(".js-tabs").tabs();
          setupBisAndSo();
        }
      });
    };
  }
};
/**
 * Applies any sort of event handlers for the switchClass.
 * @param  {jQuery} $el - link
 * @param  {Object} [options={}] - Any options provided upon initialization
 */


var setEventListeners = function setEventListeners($el, $saveSizeTrigger, opts) {
  $saveSizeTrigger.on('click', function (evt) {
    evt.preventDefault();
    getSizes($el, $saveSizeTrigger, opts);
  });
};
/**
 * Initializes sizeSelection.
 * @param {jQuery} el - targeting the element of the plp list
 * @param {Object} options - Options used for wiring up the sizeSelection
 * @see DEFAULTS
 */


function sizeSelection(el) {
  var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
  var $el = __WEBPACK_IMPORTED_MODULE_0_jquery___default()(el);
  var opts = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2_styleguide_lib_merge_options__["a" /* default */])(DEFAULTS, options, $el);
  var $saveSizeTrigger = $el.find(SS_TRIGGER_CLASS);
  setEventListeners($el, $saveSizeTrigger, opts);
}
__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_styleguide_lib_register_jquery_plugin__["a" /* default */])(PLUGIN_NAME, sizeSelection);

/***/ }),

/***/ 323:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_jquery__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_jquery___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_jquery__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__plp_lazy_load__ = __webpack_require__(29);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__size_selection__ = __webpack_require__(206);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__ab_3336_view_more_cta__ = __webpack_require__(197);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_modules_heart_product__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__pdp_bis_and_so__ = __webpack_require__(27);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__manage_refine_menu__ = __webpack_require__(28);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__plpswatches__ = __webpack_require__(62);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__my_favorite__ = __webpack_require__(205);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__amp_category_menu__ = __webpack_require__(199);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__amp_favorite__ = __webpack_require__(201);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__amp_filters__ = __webpack_require__(202);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__amp_favorite_brand__ = __webpack_require__(200);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13_modules_add_to_bag__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14_styleguide_modules_product_filter_active_button__ = __webpack_require__(171);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15_styleguide_modules_product_filter_search__ = __webpack_require__(173);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16_styleguide_modules_product_filter_count__ = __webpack_require__(61);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17_styleguide_modules_product_filter_clear_all__ = __webpack_require__(172);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18__add_to_bag__ = __webpack_require__(198);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_19__modules_revieve_try_on__ = __webpack_require__(34);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_20__cpl_banner__ = __webpack_require__(203);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_21_modules_social_proof__ = __webpack_require__(21);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_22__loyalty_favorites__ = __webpack_require__(204);


















 // required for plpAddToBag method





window.setupBisAndSo = __WEBPACK_IMPORTED_MODULE_5__pdp_bis_and_so__["a" /* default */];

window.addToBagWithData = function (data, callbacks, addToBagUrl) {
  if (data.fromZelig) {
    callbacks = {};

    callbacks.success = function () {
      insertPageTrackForMobileWithData({
        addToCartFlag: true,
        productCode: data.code,
        isZeligAddToBag: true
      });
    };
  }

  __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_13_modules_add_to_bag__["a" /* addToBagWithData */])(data, callbacks, addToBagUrl);
};

function bindHeartItems(container) {
  if (typeof container === "undefined") {
    __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4_modules_heart_product__["a" /* default */])('.js-page-items', '.fav-item');
  } else {
    __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4_modules_heart_product__["a" /* default */])(container, '.fav-item');
  }
}

function closeLimitLightBox(elemId) {
  __WEBPACK_IMPORTED_MODULE_0_jquery___default()('#' + elemId).removeClass('u-block');
}

function clearOldFavItems() {
  __WEBPACK_IMPORTED_MODULE_0_jquery___default.a.ajax({
    type: 'GET',
    url: '/r/ajaxHeartProduct.jsp?action_T=clearolditems',
    success: function success() {
      location.reload();
    }
  });
}

function getQueryParamValues(url, param) {
  var result = [];

  if (url) {
    var paramsAndValues = url.slice(url.indexOf('?') + 1).split('&');

    for (var i = 0; i < paramsAndValues.length; i++) {
      if (paramsAndValues[i]) {
        var paramAndValue = paramsAndValues[i].split('=');

        if (2 == paramAndValue.length && param == paramAndValue[0] && paramAndValue[1]) {
          // Inverse of $.param, which is used in getFilterParams
          var value = decodeURIComponent(paramAndValue[1].replace(/\+/g, ' '));
          result.push(value);
        }
      }
    }
  }

  return result;
}

function loadShopMoreSection() {
  var relatedProductsDiv = __WEBPACK_IMPORTED_MODULE_0_jquery___default()('#relatedProductsLazyLoadDiv');

  if (relatedProductsDiv.length && typeof window.rcProps.shopMoreProductsURL !== "undefined") {
    __WEBPACK_IMPORTED_MODULE_0_jquery___default()('#plp-prod-list').parent().addClass("u-border-b u-margin-b--xxl u-border--xs u-border--color-lighter");
    var listname = relatedProductsDiv.data("listName");
    var numberOFProductsToLoad = relatedProductsDiv.data("productCount");
    var pageNum = relatedProductsDiv.data("pageNumber");
    var cplid = relatedProductsDiv.data("cplId");
    var data = "listname=" + listname + "&numberOfProducts=" + numberOFProductsToLoad + "&pageNum=" + pageNum + "&cplId=" + cplid;
    __WEBPACK_IMPORTED_MODULE_0_jquery___default.a.ajax({
      url: window.rcProps.shopMoreProductsURL,
      type: 'POST',
      data: data,
      success: function success(markup) {
        relatedProductsDiv.append(markup);
        relatedProductsDiv.find('.js-lazy-image').lazy({
          effect: 'fadeIn',
          effectTime: 300
        });
        bindHeartItems(relatedProductsDiv);
        __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_7__plpswatches__["a" /* default */])();
        loadPagination();
      }
    });
  }
}

function bindSimilarItemsExpansion() {
  __WEBPACK_IMPORTED_MODULE_0_jquery___default()('.js-similar-item').click(function (e) {
    e.preventDefault();
    __WEBPACK_IMPORTED_MODULE_0_jquery___default.a.modal({
      url: "/r/mobile/dialog/SimilarItemsView.jsp?d=" + __WEBPACK_IMPORTED_MODULE_0_jquery___default()(this).data("department"),
      data: {
        code: __WEBPACK_IMPORTED_MODULE_0_jquery___default()(this).data("pcode")
      },
      type: "toast",
      triggerOpen: true,
      onLoad: function onLoad() {
        __WEBPACK_IMPORTED_MODULE_0_jquery___default()('.modal__content').css('padding-right', '0');
      },
      onClose: function onClose() {
        __WEBPACK_IMPORTED_MODULE_0_jquery___default()('.modal__content').css('padding-right', '16');
      }
    });
  });
} // Methods to set, add, and remove Progress Bar for slow connections


function appendModalProgressBar() {
  if (!__WEBPACK_IMPORTED_MODULE_0_jquery___default()('.modal-overlay').length) {
    __WEBPACK_IMPORTED_MODULE_0_jquery___default()('<div class="modal-overlay"></div>').appendTo('body');
  }

  if (!__WEBPACK_IMPORTED_MODULE_0_jquery___default()('.modal-overlay__progress-bar').length) {
    __WEBPACK_IMPORTED_MODULE_0_jquery___default()("<div class=\"modal-overlay__progress-bar modal-overlay__progress-bar--hidden progress-bar progress-bar--center\" tabindex=\"-1\">\n        <div class=\"u-screen-reader\">\n            Content is Loading.\n        </div>\n     </div>").appendTo('.modal-overlay');
  }

  return;
}

function activateModalProgressBar() {
  __WEBPACK_IMPORTED_MODULE_0_jquery___default()('.modal-overlay').addClass('is-active');
  __WEBPACK_IMPORTED_MODULE_0_jquery___default()('.modal-overlay__progress-bar').removeClass('modal-overlay__progress-bar--hidden');
  __WEBPACK_IMPORTED_MODULE_0_jquery___default()('body').addClass('body--modal-overflow-hidden');
  return;
}

function deactivateModalProgressBar() {
  __WEBPACK_IMPORTED_MODULE_0_jquery___default()('body').removeClass('body--modal-overflow-hidden');
  __WEBPACK_IMPORTED_MODULE_0_jquery___default()('.modal-overlay__progress-bar').addClass('modal-overlay__progress-bar--hidden');
  __WEBPACK_IMPORTED_MODULE_0_jquery___default()('.modal-overlay').removeClass('is-active');
  return;
} // add to bag plp select size


function loadSizeMenu(code) {
  appendModalProgressBar();
  activateModalProgressBar();
  var sizeContent = __WEBPACK_IMPORTED_MODULE_0_jquery___default()('#add-to-bag-' + code).html();

  if (sizeContent.indexOf('fixed-overlay__item') >= 0) {
    //Remove the modal overlay and progress bar
    deactivateModalProgressBar(); //Remove the ability to scroll main content while overlay is present

    __WEBPACK_IMPORTED_MODULE_0_jquery___default()('body').css({
      'overflow-y': 'hidden'
    });
    __WEBPACK_IMPORTED_MODULE_0_jquery___default()('#size-menu-' + code).addClass("fixed-overlay__scroll--active");
    return;
  }

  __WEBPACK_IMPORTED_MODULE_0_jquery___default.a.ajax({
    type: "GET",
    url: "/r/ajax/GetProductSizeMenu.jsp?code=" + code,
    success: function success(rtn) {
      __WEBPACK_IMPORTED_MODULE_0_jquery___default()(".js-size-menu-container").each(function () {
        if (__WEBPACK_IMPORTED_MODULE_0_jquery___default()(this).hasClass('fixed-overlay__container')) {
          __WEBPACK_IMPORTED_MODULE_0_jquery___default()(this).empty();
        }
      });
      __WEBPACK_IMPORTED_MODULE_0_jquery___default()('#add-to-bag-' + code).html(rtn); //Remove the modal overlay and progress bar

      deactivateModalProgressBar(); //Remove the ability to scroll main content while overlay is present

      __WEBPACK_IMPORTED_MODULE_0_jquery___default()('body').css({
        'overflow-y': 'hidden'
      });
      __WEBPACK_IMPORTED_MODULE_0_jquery___default()('#size-menu-' + code).addClass("fixed-overlay__scroll--active");
    }
  });
}
/*
 * Favorites PLP - delete favorite list
 */

/*
* PLP Pagination Dropdown AB Test
*/


function loadPagination() {
  __WEBPACK_IMPORTED_MODULE_0_jquery___default()('.pagination__dropdown-ab-test').on('click', function (e) {
    e.stopPropagation();
    __WEBPACK_IMPORTED_MODULE_0_jquery___default()('.pagination__dropdown-content-ab-test').toggleClass('u-block');
    __WEBPACK_IMPORTED_MODULE_0_jquery___default()('.pagination__dropdown-ab-test').toggleClass('u-border--black');
  });
}

document.documentElement.addEventListener('click', function () {
  var dropdownMenu = document.getElementsByClassName('pagination__dropdown-ab-test');

  if (dropdownMenu.length > 0 && dropdownMenu[0].classList.contains('u-border--black')) {
    __WEBPACK_IMPORTED_MODULE_0_jquery___default()('.pagination__dropdown-content-ab-test').toggleClass('u-block');
    __WEBPACK_IMPORTED_MODULE_0_jquery___default()('.pagination__dropdown-ab-test').toggleClass('u-border--black');
  }
});

function closeSizeMenu(code) {
  //Add back the ability to scroll main content when overlay is closed
  __WEBPACK_IMPORTED_MODULE_0_jquery___default()('body').css({
    'overflow-y': 'auto'
  });
  __WEBPACK_IMPORTED_MODULE_0_jquery___default()('#size-menu-' + code).removeClass("fixed-overlay__scroll--active");
}

function openNotifyMeModal() {
  var data = __WEBPACK_IMPORTED_MODULE_0_jquery___default.a.param({
    code: __WEBPACK_IMPORTED_MODULE_0_jquery___default()(this).data('code'),
    size: __WEBPACK_IMPORTED_MODULE_0_jquery___default()(this).data("sizeSelected")
  });
  __WEBPACK_IMPORTED_MODULE_0_jquery___default.a.modal({
    url: window.rcProps.backInStockSpecialOrderHref,
    data: data,
    type: "full",
    open: null,
    cache: false,
    overlayClose: true,
    triggerOpen: true,
    onComplete: function onComplete() {
      __WEBPACK_IMPORTED_MODULE_0_jquery___default()(".js-tabs").tabs();
    }
  });
} // Mock Content Start - UX-17928


window.bindSizeGuideEvent = function () {
  __WEBPACK_IMPORTED_MODULE_0_jquery___default()('.js-size-guide-modal').on('click', function () {
    if (__WEBPACK_IMPORTED_MODULE_0_jquery___default()(this).data('fitPredictorCode') && __WEBPACK_IMPORTED_MODULE_0_jquery___default()(this).data('showDynamicSizeGuide')) {
      ssp('start', 'sizeguide');
      ssp('track', 'triggerSizeGuide', {
        productId: __WEBPACK_IMPORTED_MODULE_0_jquery___default()(this).data('fitPredictorCode'),
        origin: 'sizeguide-cta'
      });
    }

    __WEBPACK_IMPORTED_MODULE_0_jquery___default.a.modal({
      url: "".concat(__WEBPACK_IMPORTED_MODULE_0_jquery___default()(this).data('url')),
      triggerOpen: true,
      type: 'full'
    });
  });
  __WEBPACK_IMPORTED_MODULE_0_jquery___default()('.view_size_guide').click(function () {
    logEngagement('Size Guide Link', 'Click');
  });
}; // Mock Content End 


__WEBPACK_IMPORTED_MODULE_0_jquery___default()(document).ready(function () {
  __WEBPACK_IMPORTED_MODULE_0_jquery___default()('.js-plp-lazy-load').plpLazyLoad({
    sessionName: 'plpSessionData',
    loadAfterCallback: function loadAfterCallback() {
      __WEBPACK_IMPORTED_MODULE_0_jquery___default()('.js-lazy-image').lazy({
        effect: 'fadeIn',
        effectTime: 300,
        threshold: 900
      });

      if (window.bindHeartEvent) {
        window.bindHeartEvent(__WEBPACK_IMPORTED_MODULE_0_jquery___default()('.js-favorite-button'));
      }

      if (window.bindColorSwatchEvent) {
        window.bindColorSwatchEvent();
      }

      if (__WEBPACK_IMPORTED_MODULE_0_jquery___default()('.js-horizontal-scroll').length) {
        __WEBPACK_IMPORTED_MODULE_0_jquery___default()('.js-horizontal-scroll').horizontalScroll();
      }

      __WEBPACK_IMPORTED_MODULE_0_jquery___default()('.js-select-size').sizeSelection();
      __WEBPACK_IMPORTED_MODULE_0_jquery___default()('.js-plp-add-to-bag').plpAddToBag();
      __WEBPACK_IMPORTED_MODULE_0_jquery___default()('.js-notify-me').on('click', openNotifyMeModal);
      __WEBPACK_IMPORTED_MODULE_0_jquery___default()('.js-lazy-video').each(function () {
        this.play();
      });
      __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_19__modules_revieve_try_on__["a" /* default */])({
        isPlp: true,
        checkAvailability: true
      });
    }
  });
  __WEBPACK_IMPORTED_MODULE_0_jquery___default()('.js-lazy-video').each(function () {
    this.play();
  });
  __WEBPACK_IMPORTED_MODULE_0_jquery___default()('.js-select-size').sizeSelection();
  __WEBPACK_IMPORTED_MODULE_0_jquery___default()('.js-plp-add-to-bag').plpAddToBag();
  __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_6__manage_refine_menu__["a" /* default */])();
  bindHeartItems();
  __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_7__plpswatches__["a" /* default */])();
  __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_8__my_favorite__["a" /* default */])();
  __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_9__amp_category_menu__["a" /* default */])();
  __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_10__amp_favorite__["a" /* default */])();
  __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_11__amp_filters__["a" /* default */])();
  __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_12__amp_favorite_brand__["a" /* default */])();
  loadShopMoreSection();
  bindSimilarItemsExpansion();
  loadPagination();
  window.closeLimitLightBox = closeLimitLightBox;
  window.clearOldFavItems = clearOldFavItems;
  window.bindHeartItems = bindHeartItems;
  window.initColorSwatches = __WEBPACK_IMPORTED_MODULE_7__plpswatches__["a" /* default */];
  window.loadShopMoreSection = loadShopMoreSection;
  window.bindSimilarItemsExpansion = bindSimilarItemsExpansion;
  window.loadSizeMenu = loadSizeMenu;
  window.closeSizeMenu = closeSizeMenu;
  window.loadPagination = loadPagination;
  window.bindSizeGuideEvent(); //initSearch();
  // setupToggleCategoryDropdown();
  // resetFilters();
  // processSorting();
  // bindBrandsURl();
  //scroll to product after login

  var scrollToCode = getQueryParamValues(location.href, "scroll");
  var $loadDnde = __WEBPACK_IMPORTED_MODULE_0_jquery___default()('#loadDnde');

  if (scrollToCode && scrollToCode.length > 0 && ($loadDnde.length === 0 || $loadDnde.val() === 'false')) {
    var productCode = scrollToCode[0];
    __WEBPACK_IMPORTED_MODULE_0_jquery___default()(window).scrollTop(__WEBPACK_IMPORTED_MODULE_0_jquery___default()('.fav-item[data-pcode="' + productCode + '"]').offset().top - 50);
  }

  __WEBPACK_IMPORTED_MODULE_0_jquery___default()('.js-notify-me').on('click', openNotifyMeModal);
  var sidePanelHref = window.rcProps.sidebarHref ? window.rcProps.sidebarHref : window.rcProps.search.sidebarHref;

  if (sidePanelHref) {
    var hrefEncoded = encodeURIComponent(window.location.href);
    __WEBPACK_IMPORTED_MODULE_0_jquery___default()('.js-side-panel-sort-filter').sidePanel({
      url: "".concat(sidePanelHref, "?url=").concat(hrefEncoded),
      onAjaxLoad: function onAjaxLoad() {
        __WEBPACK_IMPORTED_MODULE_0_jquery___default()('.js-accordion-side-nav').accordion({
          onLoad: function onLoad() {
            __WEBPACK_IMPORTED_MODULE_0_jquery___default()('.side-panel__panel').animate({
              scrollTop: 0
            }, 200);
          }
        });
        __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_6__manage_refine_menu__["a" /* default */])();
        __WEBPACK_IMPORTED_MODULE_0_jquery___default()('.js-product-filter-clear-all').productFilterClearAll();
        __WEBPACK_IMPORTED_MODULE_0_jquery___default()('.js-product-filter-search').productFilterSearch();
        __WEBPACK_IMPORTED_MODULE_0_jquery___default()('.js-product-filter-active-button').productFilterActiveButton();
        __WEBPACK_IMPORTED_MODULE_0_jquery___default()('.js-product-filter-count').productFilterCount();
        __WEBPACK_IMPORTED_MODULE_0_jquery___default()('#side-panel__overlay, #done_filters').on('click', function () {
          if (__WEBPACK_IMPORTED_MODULE_0_jquery___default()('.js-product-filter-clear-all').length) {
            __WEBPACK_IMPORTED_MODULE_0_jquery___default()('.js-accordion-side-nav').accordion('closeAll');
          }
        });
      },
      returnFocus: '#sortRefineBtn'
    });
    __WEBPACK_IMPORTED_MODULE_0_jquery___default()('.js-side-panel-sort-filter').on('click', function () {
      logEngagement(window.location.href, 'Filter & Sort Side Panel', 'Click');
    });
  } // UX-13654 - Rich Nav - Start


  function richNav() {
    var body = document.body;
    var content = document.getElementById('content');
    var navSidePageWrapper = document.getElementById('nav-side-page-wrapper');
    var plpProductsContents = document.getElementById('plp-products-contents');
    var plpProductsContentsOffsetTop = plpProductsContents.offsetTop;
    var stickyButtons = document.querySelector(".js-sticky-buttons"); // Keep track of how far the client has scrolled

    window.addEventListener('scroll', function () {
      document.documentElement.style.setProperty('--scroll-y', "".concat(window.scrollY, "px"));
    });
    __WEBPACK_IMPORTED_MODULE_0_jquery___default()(document).on('click', '.js-nav-side__overlay', function () {
      closeRichNav();
    });
    __WEBPACK_IMPORTED_MODULE_0_jquery___default()('.js-nav-open').on('click', showRichNav); // Rich Nav is Closed

    function closeRichNav() {
      var scrollY = body.style.top;
      navSidePageWrapper.classList.remove('nav__sidebar--open');
      body.style.position = 'static';
      body.style.top = '';
      body.style.overflow = '';
      window.scrollTo(0, parseInt(scrollY || '0') * -1);

      if (parseInt(scrollY || '0') * -1 > plpProductsContentsOffsetTop) {
        stickyButtons.classList.remove('persisitScrolled');
      }
    } // Rich Nav is Open


    function showRichNav() {
      var scrollY = document.documentElement.style.getPropertyValue('--scroll-y');
      navSidePageWrapper.classList.add('nav__sidebar--open');
      body.style.position = 'fixed';
      body.style.top = "-".concat(scrollY);
      body.style.overflow = 'hidden';
      content.style.height = '100%';

      if (parseInt(scrollY) > plpProductsContentsOffsetTop) {
        stickyButtons.classList.add('persisitScrolled');
      }
    }
  }

  richNav(); // UX-13654 - Rich Nav - End
  // UX-13654 - Sticky Buttons - Hide/Show

  function stickyButtons() {
    var _this = this;

    var stickyButtons = document.querySelector(".js-sticky-buttons");
    var stickyButtonsIcon = document.querySelector(".js-sticky-buttons__icon");
    var plpProductsContents = document.getElementById('plp-products-contents');
    var plpProductsContentsOffsetTop = plpProductsContents.offsetTop; // Check if Sticky Buttons exist

    if (__WEBPACK_IMPORTED_MODULE_0_jquery___default()(stickyButtons).length) {
      // Add click event to sticky buttons icon to scroll to Visual Nav
      if (__WEBPACK_IMPORTED_MODULE_0_jquery___default()(stickyButtonsIcon).length) {
        var visNav = document.querySelector(".js-visual-nav");
        var visNavOffsetTop = visNav.offsetTop;
        __WEBPACK_IMPORTED_MODULE_0_jquery___default()(stickyButtonsIcon).on("click", function () {
          __WEBPACK_IMPORTED_MODULE_0_jquery___default()('html, body').animate({
            scrollTop: visNavOffsetTop
          }, 300);
        });
      } // Check window position to show Sticky Buttons


      window.addEventListener('scroll', function () {
        var scrollPos = __WEBPACK_IMPORTED_MODULE_0_jquery___default()(_this).scrollTop();

        if (scrollPos > plpProductsContentsOffsetTop) {
          stickyButtons.classList.add('scrolled');
        } else {
          stickyButtons.classList.remove('scrolled');
        }
      });
    }
  }

  stickyButtons(); // UX-13654 - Sticky Buttons - End

  __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_20__cpl_banner__["a" /* default */])();
  __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_19__modules_revieve_try_on__["a" /* default */])({
    isPlp: true,
    checkAvailability: !__WEBPACK_IMPORTED_MODULE_0_jquery___default()('.js-plp-lazy-load').length
  });
  __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_21_modules_social_proof__["a" /* renderPlpSocialProof */])(__WEBPACK_IMPORTED_MODULE_0_jquery___default()('.js-plp-container').toArray().map(function (el) {
    return __WEBPACK_IMPORTED_MODULE_0_jquery___default()(el).prop('id');
  }));
});
document.addEventListener('WidgetModalOpen', function (e) {
  logEngagement(window.location.href, 'Zelig', 'PLP widget clicks');
});

/***/ }),

/***/ 61:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export PLUGIN_NAME */
/* unused harmony export DEFAULTS */
/* unused harmony export default */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_jquery__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_jquery___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_jquery__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_styleguide_lib_merge_options__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__lib_register_jquery_plugin__ = __webpack_require__(1);
/**
 * Toggle Text on click
 * @module toggleText
 */



var PLUGIN_NAME = 'productFilterCount';
var DEFAULTS = {};

var countChecked = function countChecked($checkboxes) {
  return $checkboxes.filter(':checked').length;
};

var renderCount = function renderCount($checkboxes, $count) {
  var count = countChecked($checkboxes);
  $count.text("(".concat(count, ")"));
  if (count === 0) $count.text('');
};

var onChangeListener = function onChangeListener($checkboxes, $count) {
  return $checkboxes.on('change', function () {
    return renderCount($checkboxes, $count);
  });
};
/**
 * Initializes productFilterCount.
 * @param {HTMLElement} container - filter container
 * @param {Object} options - Options used for wiring up the plugin
 * @see DEFAULTS
 */


function productFilterCount(container) {
  var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
  var $container = __WEBPACK_IMPORTED_MODULE_0_jquery___default()(container);
  var opts = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_styleguide_lib_merge_options__["a" /* default */])(DEFAULTS, options, $container);
  var $count = __WEBPACK_IMPORTED_MODULE_0_jquery___default()(opts.filterCount);
  var $checkboxes = $container.find('input[type="checkbox"]');
  renderCount($checkboxes, $count);
  onChangeListener($checkboxes, $count);
}
__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__lib_register_jquery_plugin__["a" /* default */])(PLUGIN_NAME, productFilterCount);

/***/ })

},[323]);


// WEBPACK FOOTER //
// dist/plp.js